export type CrossPropertySurface =
  | 'planner'
  | 'portal'
  | 'landing'
  | 'manual'
  | 'hunt'
  | 'gvwr'
  | 'ampsmart';

export interface CrossPropertyLinkOptions {
  url: string;
  destination: CrossPropertySurface;
  campaign: string;
  placementId?: string;
}

export function useCrossPropertyLink(opts: CrossPropertyLinkOptions): string {
  const url = new URL(opts.url);
  url.searchParams.set('mtm_source', 'events');
  url.searchParams.set('mtm_medium', 'cross_property');
  url.searchParams.set('mtm_campaign', opts.campaign);
  if (opts.placementId) {
    url.searchParams.set('mtm_content', opts.placementId);
  }
  return url.toString();
}
